export default __webpack_public_path__ + "static/iphone-app-screens@2x-d2d89bdb9a30d67aaf2f232c3901a391.png";